import React from 'react'
import { Form } from 'semantic-ui-react'
import _ from 'lodash'

export default class BranchesField extends React.PureComponent {
  generateDropDownBranches = () => {
    const { allBranches, promotions } = this.props

    const allPromotionBranch = _.map(promotions, 'branch_id')

    const selectOptions = _.reduce(
      allBranches,
      (result, branch) => {
        if (!allPromotionBranch.includes(branch.key)) {
          result.push({
            text: branch.name,
            value: branch.key,
          })
        }

        return result
      },
      []
    )

    return selectOptions
  }

  render() {
    const { onChange, value } = this.props

    return (
      <Form.Select
        fluid
        options={this.generateDropDownBranches()}
        label="Branches"
        placeholder="Please choose branch"
        onChange={(e, data) => onChange(data.value)}
        value={value}
        required
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/promotions/fields/branchesField.js